export const langHome = {
  fr: {
    home: 'Home',
    use: 'Utiliser',
    home0: `WSurf`,
    home1: 'Vous utilisez un GPS pendant vos sessions Wind, Kite ou Wing ?',
    home2:
      "Vous avez envie d'en savoir plus sur vos sessions ? Vitesse max, vitesse instantanée, durée, distance, déroulement de la session, trace GPS, matériel utilisé, météo à proximité...",
    home3:
      'Vous aimeriez conserver vos données GPS et pouvoir y revenir facilement ?',
    home4: 'Alors ',
    home5: 'commencez à exploiter les données GPS ',
    home6: 'contenues dans vos enregistrements gpx ou fit.',
    home7: "Vous pouvez également jeter un coup d'oeil à ",
    home8: 'ce petit exemple ',
    home9: "d'utilisateur enregistré.",
  },
  eng: {
    home: 'Home',
    use: 'Use',
    home0: `WSurf`,
    home1: 'Do you ever use a GPS during your Wind, Kite or Wing sessions?',
    home2:
      'You want to know more about your sessions ? Max speed, current speed, duration, distance, session progress, GPS track, equipment used, nearby weather...',
    home3:
      'You would like to keep this data and be able to return to it easily ?',
    home4: 'So ',
    home5: 'start exploiting GPS data',
    home6: 'contained in your gpx or fit records.',
    home7: 'You can also take a look at ',
    home8: 'this short example ',
    home9: 'of a registered user.',
  },
}
